// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --padding: 0;
  --width: auto;
  --margin: 0;
}
:host .input-search-toolbar {
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--padding);
  margin: var(--margin);
  gap: var(--space-sm);
}
:host .input-search-toolbar flw-search {
  flex: 1;
  min-width: 0;
}
:host .input-search-toolbar .input-close-button ion-button {
  height: auto !important;
  width: auto !important;
}
:host .input-search-toolbar .input-close-button ion-button ion-icon {
  font-size: 32px;
}
:host[size=small] .input-search-toolbar flw-search {
  --space-md: 10px;
}

@media (min-width: 768px) {
  :host {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/input-search/input-search.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AACR;AACQ;EACI,OAAA;EACA,YAAA;AACZ;AAGY;EACI,uBAAA;EACA,sBAAA;AADhB;AAEgB;EACI,eAAA;AAApB;AAOY;EACI,gBAAA;AALhB;;AAUA;EACE;IACE,cAAA;IACA,WAAA;IACA,sBAAA;EAPF;AACF","sourcesContent":[":host {\r\n    --padding: 0;\r\n    --width: auto;\r\n    --margin: 0;\r\n\r\n    .input-search-toolbar {\r\n        display: flex;\r\n        align-items: center;\r\n        width: 100%;\r\n        padding: var(--padding);\r\n        margin: var(--margin);\r\n        gap: var(--space-sm);\r\n\r\n        flw-search {\r\n            flex: 1;\r\n            min-width: 0;\r\n        }\r\n\r\n        .input-close-button {\r\n            ion-button {\r\n                height: auto !important;\r\n                width: auto !important;\r\n                ion-icon {\r\n                    font-size: 32px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &[size='small'] {\r\n        .input-search-toolbar {\r\n            flw-search {\r\n                --space-md: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n@media (min-width: 768px) {\r\n  :host {\r\n    display: block;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
